export default {
    save: 'Save',
};
